export const supportEmail = 'murilo@contextualize.ai';

export const supportTwitterUsername = 'mpereira';

// From environment variables //////////////////////////////////////////////////

export const FRONTEND_WEBSITE_URL =
  process.env.NEXT_PUBLIC_FRONTEND_WEBSITE_URL ||
  process.env.NEXT_PUBLIC_FRONTEND_WEBSITE_URL;

// Stripe //////////////////////////////////////////////////////////////////////

export const tier0MonthlyPlan = {
  id: process.env.NEXT_PUBLIC_STRIPE_TIER_0_MONTHLY_PLAN_ID,
  productName: 'Hobby Data Journalist',
  billingIntervalUnit: 'month',
  priceInCents: Number(
    process.env.NEXT_PUBLIC_STRIPE_TIER_0_MONTHLY_PLAN_AMOUNT
  ),
  priceMarkdownInCents: Number(
    process.env.NEXT_PUBLIC_STRIPE_TIER_0_MONTHLY_PLAN_MARKDOWN
  ),
};

export const tier0YearlyPlan = {
  id: process.env.NEXT_PUBLIC_STRIPE_TIER_0_YEARLY_PLAN_ID,
  productName: 'Hobby Data Journalist',
  billingIntervalUnit: 'year',
  priceInCents: Number(
    process.env.NEXT_PUBLIC_STRIPE_TIER_0_YEARLY_PLAN_AMOUNT
  ),
  priceMarkdownInCents: Number(
    process.env.NEXT_PUBLIC_STRIPE_TIER_0_YEARLY_PLAN_MARKDOWN
  ),
};

export const tier1MonthlyPlan = {
  id: process.env.NEXT_PUBLIC_STRIPE_TIER_1_MONTHLY_PLAN_ID,
  productName: 'Professional Data Journalist',
  billingIntervalUnit: 'month',
  priceInCents: Number(
    process.env.NEXT_PUBLIC_STRIPE_TIER_1_MONTHLY_PLAN_AMOUNT
  ),
  priceMarkdownInCents: Number(
    process.env.NEXT_PUBLIC_STRIPE_TIER_1_MONTHLY_PLAN_MARKDOWN
  ),
};

export const tier1YearlyPlan = {
  id: process.env.NEXT_PUBLIC_STRIPE_TIER_1_YEARLY_PLAN_ID,
  productName: 'Professional Data Journalist',
  billingIntervalUnit: 'year',
  priceInCents: Number(
    process.env.NEXT_PUBLIC_STRIPE_TIER_1_YEARLY_PLAN_AMOUNT
  ),
  priceMarkdownInCents: Number(
    process.env.NEXT_PUBLIC_STRIPE_TIER_1_YEARLY_PLAN_MARKDOWN
  ),
};

export const planTiers = {
  tier0Plans: {
    monthly: tier0MonthlyPlan,
    yearly: tier0YearlyPlan,
  },
  tier1Plans: {
    monthly: tier1MonthlyPlan,
    yearly: tier1YearlyPlan,
  },
};

////////////////////////////////////////////////////////////////////////////////

// Vega.

export const DEFAULT_MOBILE_CHART_WIDTH = 640;
export const DEFAULT_MOBILE_CHART_HEIGHT = 360;

export const DEFAULT_DESKTOP_CHART_WIDTH = 1200;
export const DEFAULT_DESKTOP_CHART_HEIGHT = 800;

export const DEFAULT_CHART_WIDTH = DEFAULT_DESKTOP_CHART_WIDTH;
export const DEFAULT_CHART_HEIGHT = DEFAULT_DESKTOP_CHART_HEIGHT;

// https://vega.github.io/vega-lite/docs/size.html#autosize
export const DEFAULT_CHART_AUTOSIZE = 'pad'; // 'pad' is the Vega default.

// Chart ///////////////////////////////////////////////////////////////////////

export const INTERVAL_SELECTION_RECT_COLOR = '#8ecae6';
export const HOVER_RECT_COLOR = '#333';
export const HOVER_TEXT_COLOR = '#222';

export const AXIS_FONT_SIZE = 16;

export const DEFAULT_IS_Y_AXIS_SCALE_ZERO_BASED = true;

// Annotation set //////////////////////////////////////////////////////////////

export const DEFAULT_ANNOTATION_STYLE_LENGTH = 30;
export const DEFAULT_ANNOTATION_FONT_SIZE = 16;

export const ANNOTATION_TIMESTAMP_FONT_SIZE = 15;
export const ANNOTATION_TIMESTAMP_VERTICAL_DISTANCE_TO_ANNOTATION_BOX = 4;

export const ANNOTATION_INDEX_FONT_SIZE = 16;
export const ANNOTATION_INDEX_TEXT_Y_OFFSET_MULTIPLIER = 0.35;

// Landing page ////////////////////////////////////////////////////////////////

export const DEMO_STORY_ID = 'ce8dea7a-c876-40a1-99c2-a3f15a54fd32';
export const HOW_IT_WORKS_STORY_ID = 'adfa749b-1b1a-4838-8bf2-21e4a138ef9b';

export const DEMO_STORY_AXIS_FONT_SIZE = 20;
export const DEMO_STORY_RIGHT_SIDE_LABEL_FONT_SIZE = 22;

// Share metadata //////////////////////////////////////////////////////////////

export const SHARE_TITLE_SUFFIX = ' · contextualize.ai';

// Twitter share thumbnail /////////////////////////////////////////////////////

// https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/summary-card-with-large-image
// https://biteable.com/tools/image-resizer/#twitter
// https://www.dimensions.com/element/twitter-website-card-image
export const TWITTER_SHARE_THUMBNAIL_WIDTH = 800;
export const TWITTER_SHARE_THUMBNAIL_HEIGHT = 418;

export const SHARE_THUMBNAIL_WIDTH = TWITTER_SHARE_THUMBNAIL_WIDTH;
export const SHARE_THUMBNAIL_HEIGHT = TWITTER_SHARE_THUMBNAIL_HEIGHT;
